<section class="sub-header">
    <!-- Show the back btn -->
    <button class="btn btn-back" (click)="location.back()">Back</button>
    <!-- Show the title -->
    <h2>Illustration Request</h2>
  </section>
  
  <section class="card mb-3 upload-box">
    <div class="card-body">
      <div class="line-of-2">
        
        <form [formGroup]="illustrationForm" class="illustration-form">

          <div class="form-group required" id="searchCountryName">
            <label for="Country">Country</label>
            <section class="d-flex filter-box mb-3 custom-filter">
              <input disabled type="text" class="form-control" id="Country" formControlName="Country">
            </section>
          </div>

          <div  class="form-group required" id="searchClientName">
            <label for="ClientName">Client Name</label>
            <section class="d-flex filter-box custom-filter">
                <input disabled type="text" placeholder="Search for a client name" required class="form-control" formControlName="ClientName">                    
            </section>
          </div>

          <div class="form-group" id="regionalDirector">
            <label for="regionalDirector">Regional director</label>
            <section class="d-flex filter-box mb-3 custom-filter">
              <input disabled type="text" class="form-control" id="regionalDirector" formControlName="RegionalDirector">
            </section>
          </div>

          <div class="form-group" id="accountRepresentative">
            <label for="accountRepresentative">Account representative</label>
            <section class="d-flex filter-box mb-3 custom-filter">
              <input disabled type="text" class="form-control" id="accountRepresentative" formControlName="AccountRepresentative">
            </section>
          </div>

          <div class="form-group required" id="opportunityId">
            <label for="opportunityId">Opportunity ID</label>
            <section class="d-flex filter-box mb-3 custom-filter">
              <input type="text" autocomplete="off" class="form-control" id="opportunityId" required #searchOpportunityField formControlName="OpportunityId">
              <ul *ngIf="!selectedOpp && illustrationForm.controls.OpportunityId.value != '' && !searchingOpp">
                <li *ngFor="let opp of filteredOpportunities" (click)="selectOpportunity(opp)">
                  <p> {{ opp.id }}</p>
                </li>
              </ul>
              <small *ngIf="searchingOpp" class="form-text text-muted">searching...</small>
            </section>
          </div>
          
      </form>
        
      
      </div>
      <div class="col-right box align-self-start mb-3 status-box">
      <div>
        <h3>Status</h3>
        <span class="status {{statusText | lowercase}}">{{statusText}}</span>
      </div>
    </div>
    <!-- Merging illustrations -->

    <div *ngIf="(!illustrations || illustrations.length == 0) && isCollaborator">
      no illustrations for this client
    </div>
    
    <div *ngIf="illustrations.length > 0 && isCollaborator" class="card-table" >
       <a *ngFor="let illustration of illustrations" class="card">
        
          <div class="card-body">
           
            <div>
            
                <h3 class="illustration-header">
                  {{ illustration.title }}
                </h3>
              
                  <h4>{{ illustration.subTitle }}</h4>  
               
               <h4>{{ illustration.displayDate | date}}</h4>
            </div>
         
         </div>
         <div class="mrg" style="display: inline-block; float: right;">
          <span class="merge"  (click)="merge(illustration)">
            <fa-icon [icon]="faCodeBranch" size="lg"></fa-icon>
          </span>
        </div>
       </a>
    </div>
      <div *ngIf="isCollaborator && isTaskOpen" >
   
        <button (click)="save()" [disabled]="!isOppSelected" class="btn btn-primary d-inline mt-3 mb-2"  type="button">
          <span *ngIf="submitRequest" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
            Submit Illustration
        </button>
    

    
        <button (click)="reject()"  [disabled]="!isOppSelected"  class="btn btn-danger d-inline mt-3 mb-2 mr-3" style="float: right" type="button">
          <span role="status" aria-hidden="true"></span>
            Reject
        </button>
  
      </div>

    </div>

  </section>


 

  <app-comment-list  [networkMemberId]="networkMemberId" [customProcessId]="'illustration-input-request'"
  [isTagSystemApplicable]="false" [taskId]="taskId" [clientName]="task?.title" [isOccurencyApplicable]="true" [service]="informativeTaskService" ></app-comment-list>

 
 